<span class="article-date nordic-blue-900-text text-icon-primary font-body-2 font-body-small">
  <ng-container *ngIf="text">{{ text }} </ng-container>{{ date | finTimestamp }}
</span>
